import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { ApiBuildingPlansConstants } from "../../constants/api-constants/api-building-plans.constants";
let BuildingPlansService = class BuildingPlansService {
    http;
    constructor(http) {
        this.http = http;
    }
    getSetProfessionalBodiesObservable(applicationId, params) {
        return this.http.post(`${ApiBuildingPlansConstants.URL}/${applicationId}/${ApiBuildingPlansConstants.FUNCTION_SET_PROFESSIONAL_BODIES}`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    getApplicationSetPropertiesObservable(applicationId, params) {
        return this.http.post(`${ApiBuildingPlansConstants.URL}/${applicationId}/${ApiBuildingPlansConstants.FUNCTION_SET_PROPERTIES}`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    verifyResubmissionReferenceNumberObservable(params) {
        return this.http.post(`${ApiBuildingPlansConstants.URL}/${ApiBuildingPlansConstants.FUNCTION_VERIFY_RESUBMISSION_REFERENCE_NUMBER}`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    verifyExtensionReferenceNumberObservable(params) {
        return this.http.post(`${ApiBuildingPlansConstants.URL}/${ApiBuildingPlansConstants.FUNCTION_VERIFY_EXTENSION_REFERENCE_NUMBER}`, params)
            .pipe(map((response) => {
            return response;
        }));
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
BuildingPlansService = __decorate([
    Injectable({
        providedIn: "root"
    })
], BuildingPlansService);
export { BuildingPlansService };
